import React, {  useState } from "react";
import DateInput from "./DateInput";
import { Formik } from "formik";

function DateInputDisplay() {
const [date1, date2] = useState();

return (
    <div>
      <Formik
        initialValues={{
          date1: "",
          date2: ""
          
        }}
        // all validation rules go in here
        validate={(values) => {
          const errors = {};

    
          // date picker
          // check date has value
          if (values.date1 === "") {
            errors.date1 = "pick a date";
          }

		  if (values.date2 === "") {
            errors.date2 = "pick a date";
          }

          // return errors object with all error strings
          return errors;
        }}
        
        validateOnBlur={true}
        validateOnChange={false}
      >
        {({
          values /* all data need to run the valdation*/,
          errors /* all error strings */,
          touched /* all field touch event  */,
          handleChange /* value change event handler */,
          handleBlur /* onBlur event handler */,
          handleSubmit /* for submit button */,
          isSubmitting /* for submit button */,
          isValid /* for submit button */,
          dirty /* for submit button */,
          validateForm
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            {/* email input box with error message */}
        
            <br />
            <hr />
            <DateInput
              id={"dateInput_1"}
              value={new Date("2022-1-12")}
              label={"Date with Confirmation"}
              isRequired={true}
              //onChange={(d) => setDI1(d == null ? "null" : d.toLocaleDateString())}

              // rsuite date picket return date string, no event
              // can not use formik handleChange or handleBlur
              // manually setup value and run validation
              onChange={(date) => {
                values.date1 = "";
                if (date) {
                  values.date1 = date.toLocaleDateString();
                }
                validateForm();

              }}
              // formik does not like the onblur event return by rsuite
              // manually setup date and run validation
              onBlur={(e) => {
                if (e.target.innerText) {
                  values.date1 = e.target.innerText; // date can be preset date from value, value={new Date("2022-12-12")}
                  //setDI1(e.target.innerText);
                }
                validateForm();
 
              }}
              // onFucuse return true
              onFocus={(e) => {
                touched.date1 = e;
              }}
              hasError={touched.date1 && errors.date1}
              errorMessage={errors.date1}
            />
            <br />
            <span class="inputbox__error">
              You picked {date1}, {values.date1}, {errors.date1}
            </span>
            <hr />
            
            <DateInput
              id={"dateInput_2"}
              
              label={"Date with NO Confirmation"}
              isRequired={false}
              disableConfirm={true}
              //onChange={(d) => setDI1(d == null ? "null" : d.toLocaleDateString())}

              // rsuite date picket return date string, no event
              // can not use formik handleChange or handleBlur
              // manually setup value and run validation
              onChange={(date) => {
                values.date2 = "";
                if (date) {
                  values.date2 = date.toLocaleDateString();
                }
                validateForm();

              }}
              // formik does not like the onblur event return by rsuite
              // manually setup date and run validation
              onBlur={(e) => {
                if (e.target.innerText) {
                  values.date2 = e.target.innerText; // date can be preset date from value, value={new Date("2022-12-12")}
               //   setDI2(e.target.innerText);
                }
                validateForm();

              }}
              // onFucuse return true
              onFocus={(e) => {
                touched.date2 = e;
              }}
              hasError={touched.date2 && errors.date2}
              errorMessage={errors.date2}
            />
            <br />
            <span class="inputbox__error">
              You picked {date2}, {values.date2}, {errors.date2}
            </span>
            <hr />
            <hr />
            
            <br />
            <br />
            -----------------------
            -----------------------
            <br />
            errors: {JSON.stringify(errors)}
            <br />

            date: {values.date1} - touched:{JSON.stringify(touched.date1)} -
            error:{errors.date1}.
            <br />
            -----------------------
          </form>
        )}
      </Formik>

      <span>date: {date1}</span>
 	-----------------------
    </div>
  );

}
export default DateInputDisplay;


